import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import AccountPropertyListUI from './AccountPropertyListUI.js'

class AccountPropertyListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      propertyList: null,
      updateMode: false,
      selectedProperty: null
    }
  }

  render() {
    return (
      <AccountPropertyListUI
        context={this.props.context}
        errorList={this.state.errorList}
        propertyList={this.state.propertyList}
        selectedProperty={this.state.selectedProperty}
        updateMode={this.state.updateMode}
        category={this.props.category}
        categoryLabel={this.props.categoryLabel}
        account={this.props.account}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccountProperties(context)
  }

  getAccountProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.account.accountId}/properties`,
      cacheKey: CacheKeys.AccountProperties(this.props.account.accountId),
      callback: this.getAccountPropertiesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountPropertiesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      propertyList: response.accountPropertyList
    })
  }

  onUpdateClick = (event) => {
    let propertyCode = event.currentTarget.getAttribute('data-property')
    console.log(propertyCode);
    let selectedProperty = this.state.propertyList.filter(p => p.propertyCode === propertyCode)[0]
    this.setState({updateMode: true, selectedProperty: selectedProperty})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, errorList: null})
  }

  onUpdate = (selectedProperty) => {
    CacheManager.removeObject(CacheKeys.AccountProperties(this.props.account.accountId))
    this.setState({propertyList : this.state.propertyList})
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.AccountProperties(this.props.account.accountId))
    if (noBusy === 'noBusy') {
      console.log('noBusy');
      this.getAccountProperties(this.props.context)
    }
    else {
      this.setState(
        {
          propertyList: null,
          errorList: null,
        }, this.getAccountProperties(this.props.context)
      )
    }
  }
}

export default AccountPropertyListSF
